import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight, ArrowLeft, MessageCircle, Music, ChevronRight, ExternalLink } from "lucide-react";
import { Footer } from "../components/Footer";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8cb5d32c-b1ce-4951-b77e-897f98e6cc9f/artifacts/uyctypm7_41ed1e03-8bc9-42a0-8314-b43b52fec9a9.JPG";

const CLUB_DATA = {
  "arsenal": {
    name: "Arsenal",
    hubTitle: "African Arsenal Fans",
    intro: "A space for African and diaspora fans of Arsenal to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [
      { title: "African Gunner Anthem", platform: "Spotify", url: "https://open.spotify.com/artist/2p4fVYvsZF323pRXdhUEDC" },
      { title: "Bantu Gunners", platform: "YouTube", url: "https://www.youtube.com/@AfroFanthem" }
    ],
    topics: [
      "Why do you support Arsenal?",
      "Which African player defines Arsenal for you?",
      "What should Arsenal do for African fans?",
      "Best Arsenal memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Arsenal next?"
    ]
  },
  "manchester-united": {
    name: "Manchester United",
    hubTitle: "Manchester United Africa Fan Hub",
    intro: "A space for African and diaspora fans of Manchester United to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [
      { title: "Never Die", platform: "Spotify", url: "https://open.spotify.com/artist/2p4fVYvsZF323pRXdhUEDC" }
    ],
    topics: [
      "Why do you support Manchester United?",
      "Which African player defines Manchester United for you?",
      "What should Manchester United do for African fans?",
      "Best Manchester United memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Manchester United next?"
    ]
  },
  "liverpool": {
    name: "Liverpool",
    hubTitle: "Liverpool Africa Fan Hub",
    intro: "A space for African and diaspora fans of Liverpool to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [
      { title: "Ubuntu: The Walk Of Many", platform: "Spotify", url: "https://open.spotify.com/artist/2p4fVYvsZF323pRXdhUEDC" }
    ],
    topics: [
      "Why do you support Liverpool?",
      "Which African player defines Liverpool for you?",
      "What should Liverpool do for African fans?",
      "Best Liverpool memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Liverpool next?"
    ]
  },
  "chelsea": {
    name: "Chelsea",
    hubTitle: "Chelsea Africa Fan Hub",
    intro: "A space for African and diaspora fans of Chelsea to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Chelsea?",
      "Which African player defines Chelsea for you?",
      "What should Chelsea do for African fans?",
      "Best Chelsea memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Chelsea next?"
    ]
  },
  "newcastle-united": {
    name: "Newcastle United",
    hubTitle: "Newcastle United Africa Fan Hub",
    intro: "A space for African and diaspora fans of Newcastle United to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [
      { title: "Magpies Assembly", platform: "Spotify", url: "https://open.spotify.com/artist/2p4fVYvsZF323pRXdhUEDC" }
    ],
    topics: [
      "Why do you support Newcastle United?",
      "Which African player defines Newcastle for you?",
      "What should Newcastle do for African fans?",
      "Best Newcastle memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Newcastle next?"
    ]
  },
  "manchester-city": {
    name: "Manchester City",
    hubTitle: "Manchester City Africa Fan Hub",
    intro: "A space for African and diaspora fans of Manchester City to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Manchester City?",
      "Which African player defines Manchester City for you?",
      "What should Manchester City do for African fans?",
      "Best Manchester City memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Manchester City next?"
    ]
  },
  "tottenham-hotspur": {
    name: "Tottenham Hotspur",
    hubTitle: "Tottenham Hotspur Africa Fan Hub",
    intro: "A space for African and diaspora fans of Tottenham Hotspur to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Tottenham?",
      "Which African player defines Tottenham for you?",
      "What should Tottenham do for African fans?",
      "Best Tottenham memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Tottenham next?"
    ]
  },
  "aston-villa": {
    name: "Aston Villa",
    hubTitle: "Aston Villa Africa Fan Hub",
    intro: "A space for African and diaspora fans of Aston Villa to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Aston Villa?",
      "Which African player defines Aston Villa for you?",
      "What should Aston Villa do for African fans?",
      "Best Aston Villa memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Aston Villa next?"
    ]
  },
  "nottingham-forest": {
    name: "Nottingham Forest",
    hubTitle: "Nottingham Forest Africa Fan Hub",
    intro: "A space for African and diaspora fans of Nottingham Forest to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Nottingham Forest?",
      "Which African player defines Forest for you?",
      "What should Nottingham Forest do for African fans?",
      "Best Nottingham Forest memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Forest next?"
    ]
  },
  "bournemouth": {
    name: "AFC Bournemouth",
    hubTitle: "Bournemouth Africa Fan Hub",
    intro: "A space for African and diaspora fans of AFC Bournemouth to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Bournemouth?",
      "Which African player defines Bournemouth for you?",
      "What should Bournemouth do for African fans?",
      "Best Bournemouth memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Bournemouth next?"
    ]
  },
  "burnley": {
    name: "Burnley",
    hubTitle: "Burnley Africa Fan Hub",
    intro: "A space for African and diaspora fans of Burnley to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Burnley?",
      "Which African player defines Burnley for you?",
      "What should Burnley do for African fans?",
      "Best Burnley memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Burnley next?"
    ]
  },
  "wolverhampton": {
    name: "Wolverhampton Wanderers",
    hubTitle: "Wolves Africa Fan Hub",
    intro: "A space for African and diaspora fans of Wolverhampton Wanderers to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Wolves?",
      "Which African player defines Wolves for you?",
      "What should Wolves do for African fans?",
      "Best Wolves memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Wolves next?"
    ]
  },
  "brighton": {
    name: "Brighton & Hove Albion",
    hubTitle: "Brighton Africa Fan Hub",
    intro: "A space for African and diaspora fans of Brighton & Hove Albion to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Brighton?",
      "Which African player defines Brighton for you?",
      "What should Brighton do for African fans?",
      "Best Brighton memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Brighton next?"
    ]
  },
  "everton": {
    name: "Everton",
    hubTitle: "Everton Africa Fan Hub",
    intro: "A space for African and diaspora fans of Everton to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Everton?",
      "Which African player defines Everton for you?",
      "What should Everton do for African fans?",
      "Best Everton memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Everton next?"
    ]
  },
  "leeds": {
    name: "Leeds United",
    hubTitle: "Leeds United Africa Fan Hub",
    intro: "A space for African and diaspora fans of Leeds United to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Leeds United?",
      "Which African player defines Leeds for you?",
      "What should Leeds United do for African fans?",
      "Best Leeds United memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Leeds next?"
    ]
  },
  "west-ham": {
    name: "West Ham United",
    hubTitle: "West Ham Africa Fan Hub",
    intro: "A space for African and diaspora fans of West Ham United to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support West Ham?",
      "Which African player defines West Ham for you?",
      "What should West Ham do for African fans?",
      "Best West Ham memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for West Ham next?"
    ]
  },
  "crystal-palace": {
    name: "Crystal Palace",
    hubTitle: "Crystal Palace Africa Fan Hub",
    intro: "A space for African and diaspora fans of Crystal Palace to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Crystal Palace?",
      "Which African player defines Crystal Palace for you?",
      "What should Crystal Palace do for African fans?",
      "Best Crystal Palace memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Palace next?"
    ]
  },
  "brentford": {
    name: "Brentford",
    hubTitle: "Brentford Africa Fan Hub",
    intro: "A space for African and diaspora fans of Brentford to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Brentford?",
      "Which African player defines Brentford for you?",
      "What should Brentford do for African fans?",
      "Best Brentford memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Brentford next?"
    ]
  },
  "sunderland": {
    name: "Sunderland",
    hubTitle: "Sunderland Africa Fan Hub",
    intro: "A space for African and diaspora fans of Sunderland to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Sunderland?",
      "Which African player defines Sunderland for you?",
      "What should Sunderland do for African fans?",
      "Best Sunderland memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Sunderland next?"
    ]
  },
  "fulham": {
    name: "Fulham",
    hubTitle: "Fulham Africa Fan Hub",
    intro: "A space for African and diaspora fans of Fulham to share stories, debate, celebrate music, and explain what the club means to them.",
    music: [],
    topics: [
      "Why do you support Fulham?",
      "Which African player defines Fulham for you?",
      "What should Fulham do for African fans?",
      "Best Fulham memory from Africa or the diaspora",
      "What chant should Afro Fanthem make for Fulham next?"
    ]
  }
};

export default function ClubHubPage() {
  const { slug } = useParams();
  const club = CLUB_DATA[slug];

  useEffect(() => {
    document.title = club ? `${club.name} Africa Fan Hub - Afro Fanthem` : "Club Hub - Afro Fanthem";
    window.scrollTo(0, 0);
  }, [slug, club]);

  if (!club) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
        <div className="text-center">
          <h1 className="font-heading text-4xl text-white uppercase mb-4">Club Not Found</h1>
          <Link to="/forum" className="text-[#FBBF24] hover:underline">Back to Forum</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            <Link to="/" className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Afro Fanthem" className="h-10 md:h-14 w-auto" />
            </Link>
            <div className="flex items-center gap-4 sm:gap-6">
              <Link to="/forum" className="text-gray-300 hover:text-white text-sm transition-colors">Forum</Link>
              <Link to="/survey" className="bg-[#FBBF24] text-black font-bold uppercase tracking-widest px-4 sm:px-6 py-2 sm:py-3 text-sm hover:bg-[#F59E0B] transition-all">
                Take the Survey
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="pt-28 md:pt-36 pb-12 px-4">
        <div className="max-w-4xl mx-auto">
          <Link to="/forum" className="inline-flex items-center gap-2 text-gray-400 hover:text-white text-sm transition-colors mb-6">
            <ArrowLeft className="w-4 h-4" />
            Back to Forum
          </Link>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-white uppercase tracking-tight mb-4" data-testid="club-hub-title">
            {club.hubTitle}
          </h1>
          <p className="text-gray-300 text-lg leading-relaxed">{club.intro}</p>
        </div>
      </section>

      {/* Music Section */}
      {club.music.length > 0 && (
        <section className="pb-12 px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-[#141414] border border-white/10 p-6 sm:p-8">
              <div className="flex items-center gap-3 mb-6">
                <Music className="w-6 h-6 text-[#10B981]" />
                <h2 className="font-heading text-2xl text-white uppercase">Club Music</h2>
              </div>
              <div className="space-y-3">
                {club.music.map((track) => (
                  <a
                    key={track.title}
                    href={track.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-between p-4 bg-white/5 border border-white/10 hover:border-[#10B981]/50 transition-all group"
                  >
                    <div className="flex items-center gap-3">
                      <Music className="w-5 h-5 text-[#10B981]" />
                      <span className="text-white font-medium">{track.title}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-400 group-hover:text-[#10B981] transition-colors">
                      <span className="text-sm">{track.platform}</span>
                      <ExternalLink className="w-4 h-4" />
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Discussion Topics */}
      <section className="pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl sm:text-3xl text-white uppercase tracking-tight mb-6">Discussion Topics</h2>
          <div className="bg-[#141414] border border-white/10 divide-y divide-white/5">
            {club.topics.map((topic) => (
              <div key={topic} className="px-6 py-4 flex items-center justify-between gap-4 hover:bg-white/[0.02] transition-colors group">
                <div className="flex items-center gap-3">
                  <MessageCircle className="w-4 h-4 text-gray-600" />
                  <span className="text-gray-300 group-hover:text-white transition-colors">{topic}</span>
                </div>
                <ChevronRight className="w-4 h-4 text-gray-600 group-hover:text-[#FBBF24] transition-colors flex-shrink-0" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Survey CTA */}
      <section className="py-16 bg-[#141414] border-t border-white/10 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-3xl text-white uppercase tracking-tight mb-4">
            Represent <span className="text-[#FBBF24]">{club.name}</span>
          </h2>
          <p className="text-gray-400 mb-8">
            Complete the survey to add your voice as an African {club.name} fan. Help prove the scale and passion of African supporters.
          </p>
          <Link to="/survey" className="inline-flex items-center gap-2 bg-[#FBBF24] text-black font-bold uppercase tracking-widest px-8 py-4 hover:bg-[#F59E0B] transition-all hover:-translate-y-1" data-testid="club-hub-survey-cta">
            Take the Survey
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
